import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
	Form,
	Button,
	Col,
	Row,
	Toast,
	Table,
	Spinner,
	Pagination,
	Tabs,
	Tab,
} from "react-bootstrap";
import styled from "styled-components";
import API from "../../network/dashboardAPI";
import { AssignmentOutlined, Payment, ViewList } from "@material-ui/icons";
import { LinearProgress, Tooltip } from "@material-ui/core";
import { logoutuser } from "../../helper/constant";
import moment from "moment";

const amountReg = new RegExp(/^[0-9]+([.][0-9]{1,2})?$/);
const orderIdReg = new RegExp(/^[0-9]+$/);

const UpArrow = "↑";
const DownArrow = "↓";
const UpDownArrow = "↑↓";

function PaymentLink() {
	if (!localStorage.getItem("admin")) logoutuser();

	const [orderId, setOrderId] = useState("");
	const [amount, setAmount] = useState("");
	const [paymentLink, setPaymentLink] = useState("");
	const [generatedPaymentLinks, setGeneratedPaymentLinks] = useState([]);
	const [loading, setLoading] = useState(false);
	const [copied, setCopied] = useState(false);

	const [searchQuery, setSearchQuery] = useState("");
	const [filter, setFilter] = useState({ search: "", page: 1, limit: 10 });
	const [orderDate, setOrderDate] = useState("");

	const limitOptions = [
		{ id: 0, label: "10", value: 10 },
		{ id: 1, label: "15", value: 15 },
		{ id: 2, label: "20", value: 20 },
		{ id: 3, label: "25", value: 25 },
		{ id: 4, label: "30", value: 30 },
	];

	const colSpan = 10;

	// Toast Message
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [toastBgColor, setToastBgColor] = useState("bg-success");
	const _toastRef = useRef(null);

	const handleShowToast = (type = "", msg = "") => {
		setShowToast(true);
		setToastMessage(msg);
		switch (type) {
			case "success":
				setToastBgColor("bg-success");
				break;
			case "fail":
				setToastBgColor("bg-danger");
				break;
			default:
				break;
		}
	};

	const handleSelectTab = (e) => {
		if (e === "list") {
			let query = {
				page: filter.page,
				limit: filter.limit,
				search: filter.search,
			};
			API.getGeneratedPaymentLinks(query)
				.then((res) => res.json())
				.then((res) => {
					if (res.success) {
						setGeneratedPaymentLinks(res.data);
					} else {
						handleShowToast("fail", res.message);
					}
					setLoading(false);
				});
		} else {
			// setFilter({ page: 1, limit: 10, search: "" });
			// setOrderDate("");
			// setSearchQuery("");
			// setOrderId("");
			// setAmount("");
			// setPaymentLink("");
		}
	};

	const handleChangeOrderId = (e) => {
		let { value } = e.target;
		setOrderId(value);
	};

	const handleChangeAmount = (e) => {
		let { value } = e.target;
		setAmount(value);
	};

	const handleChangeFilters = (type, e = "", target = "") => {
		switch (type) {
			case "limit":
				setFilter({
					...filter,
					page: 1,
					limit: parseInt(e.target.value),
				});
				break;
			case "page":
				switch (target) {
					case "first":
						if (filter.page === 1) return;
						setFilter({
							...filter,
							page: 1,
						});
						break;
					case "back":
						if (filter.page === 1) return;
						setFilter({
							...filter,
							page: filter.page - 1,
						});
						break;
					case "next":
						if (filter.page === generatedPaymentLinks?.totalPages) return;
						setFilter({
							...filter,
							page: filter.page + 1,
						});
						break;
					case "last":
						if (filter.page === generatedPaymentLinks?.totalPages) return;
						setFilter({
							...filter,
							page: generatedPaymentLinks?.totalPages,
						});
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}
	};

	const handleChangeSearchQuery = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleSortOrderDate = () => {
		switch (orderDate) {
			case "":
				setOrderDate("ASC");
				break;
			case "ASC":
				setOrderDate("DESC");
				break;
			default:
				setOrderDate("ASC");
				break;
		}
	};

	const handleCopyPaymentLink = (link) => {
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 3000);
		return navigator?.clipboard?.writeText(link);
	};

	const handleSubmitSearch = (e) => {
		e.preventDefault();
		setFilter({ ...filter, search: searchQuery });
	};

	const handleSubmitForm = (e) => {
		e.preventDefault();
		setLoading(true);
		setShowToast(false);
		API.generatePaymentLink({
			order_id: orderId,
			amount: parseFloat(amount).toFixed(2),
		})
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					setPaymentLink(res.data.payment_link);
					handleShowToast("success", "Link generated successfully!");
				} else {
					handleShowToast("fail", res.message);
				}
				setLoading(false);
			});
	};

	const handleResetFormGenerate = () => {
		setOrderId("");
		setAmount("");
		setPaymentLink("");
	};

	const getCurrencyFormatDisplay = (amount) => {
		let f = new Intl.NumberFormat(undefined, {
			style: "currency",
			currency: "USD",
			useGrouping: true,
		});

		return f.format(amount || 0);
	};

	const getDateFormatDisplay = (date) => {
		return moment(date).format("DD/MMM/YY - hh:mm A");
	};

	const isExpired = (date) => {
		// Note: the links were set from backend to be expired in one day
		let hours = moment().diff(moment(date), "hours", true);
		if (hours >= 24) return true;
		return false;
	};

	useEffect(() => {
		setLoading(true);
		let query = {
			page: filter.page,
			limit: filter.limit,
			search: filter.search,
			orderDate,
		};
		API.getGeneratedPaymentLinks(query)
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					setGeneratedPaymentLinks(res.data);
				} else {
					handleShowToast("fail", res.message);
				}
				setLoading(false);
			});
	}, [filter.search, filter.page, filter.limit, orderDate]);

	return (
		<HelpPageWrapper>
			<h4 className="mb-3">Generate Payment Link</h4>
			<Tabs defaultActiveKey={"list"} onSelect={(e) => handleSelectTab(e)}>
				<Tab
					eventKey={"list"}
					title={
						<div className="d-flex align-items-center justify-content-center">
							<ViewList className="mr-1" />
							List
						</div>
					}
					className="p-2"
				>
					<Row>
						<Col xs={12} className="pb-2">
							<Row>
								<Col xs={12} md={4}>
									<Form as="form" className="d-flex" onSubmit={handleSubmitSearch}>
										<Form.Control
											as="input"
											type="search"
											placeholder="Search"
											value={searchQuery}
											onChange={(e) => handleChangeSearchQuery(e)}
										/>
										<Button type="submit" variant="outline-primary" className="ml-2">
											Enter
										</Button>
									</Form>
								</Col>
								<Col xs={12} md={8} className="mt-2 mt-md-0">
									<div className="w-100 d-flex justify-content-end">
										<Form.Control
											as="select"
											style={{ width: "90px", marginRight: "1rem" }}
											value={filter.limit}
											onChange={(e) => handleChangeFilters("limit", e, "")}
										>
											{limitOptions?.map((limit) => {
												return (
													<option key={limit.id} value={limit.value}>
														{limit.label}
													</option>
												);
											})}
										</Form.Control>
										<Pagination>
											<Pagination.First
												onClick={() => handleChangeFilters("page", "", "first")}
												disabled={
													generatedPaymentLinks?.list?.length === 0 || filter.page === 1
												}
											/>
											<Pagination.Prev
												onClick={() => handleChangeFilters("page", "", "back")}
												disabled={
													generatedPaymentLinks?.list?.length === 0 || filter.page === 1
												}
											/>
											<Pagination.Item disabled>
												{generatedPaymentLinks?.totalPages > 0
													? filter.page + " / " + generatedPaymentLinks?.totalPages
													: "0 / 0"}
											</Pagination.Item>
											<Pagination.Next
												onClick={() => handleChangeFilters("page", "", "next")}
												disabled={
													generatedPaymentLinks?.list?.length === 0 ||
													filter.page === generatedPaymentLinks?.totalPages ||
													!generatedPaymentLinks?.totalPages
												}
											/>
											<Pagination.Last
												onClick={() => handleChangeFilters("page", "", "last")}
												disabled={
													generatedPaymentLinks?.length === 0 ||
													filter.page === generatedPaymentLinks?.totalPages ||
													!generatedPaymentLinks?.totalPages
												}
											/>
										</Pagination>
									</div>
								</Col>
							</Row>
						</Col>
						<Col xs={12}>
							<TableContent
								style={{
									maxHeight: `${window.innerHeight - 250}px`,
									overflowY: "scroll",
								}}
							>
								<Table striped bordered hover responsive>
									<thead>
										<tr>
											<th>Order ID</th>
											<th>Payment Link</th>
											<th>Amount</th>
											<th>Status</th>
											<th>Payment Token</th>
											<th>Order Reference</th>
											<th>Bank Payment Reference</th>
											<th>Payment Option</th>
											<th>Notify Date</th>
											<th role="button" onClick={handleSortOrderDate}>
												Created At{" "}
												{orderDate !== ""
													? orderDate === "ASC"
														? UpArrow
														: DownArrow
													: UpDownArrow}
											</th>
										</tr>
									</thead>
									<tbody>
										{loading ? (
											<tr>
												<td colSpan={colSpan}>
													<Spinner
														animation="border"
														variant="secondary"
														className="d-block mx-auto"
													/>
												</td>
											</tr>
										) : generatedPaymentLinks?.list?.length ? (
											generatedPaymentLinks?.list?.map((item, index) => {
												return (
													<tr key={index}>
														<td>
															<Link
																target="_blank"
																to={{ pathname: "/admin/order/details/" + item?.order_id }}
															>
																{item?.order_id ?? "N/A"}
															</Link>
														</td>
														<td>
															<div className="d-flex align-items-center justify-content-between">
																<Link
																	target="_blank"
																	to={{ pathname: item?.payment_link ?? "" }}
																>
																	{item?.payment_link ?? "N/A"}
																</Link>
																<Tooltip title="Copy to clipboard" arrow>
																	<Button
																		variant="outline-info"
																		size="sm"
																		className="ml-3"
																		onClick={() =>
																			handleCopyPaymentLink(item?.payment_link ?? "")
																		}
																	>
																		<AssignmentOutlined fontSize="small" />
																	</Button>
																</Tooltip>
															</div>
														</td>
														<td>
															<p>{getCurrencyFormatDisplay(item?.amount)}</p>
														</td>
														<td>
															<p
																style={{ fontWeight: "500" }}
																className={
																	isExpired(item.createdAt) && item?.is_paid === 0
																		? "text-danger"
																		: item?.payment_status === "SUCCESS"
																		? "text-success"
																		: "text-warning"
																}
															>
																{isExpired(item.createdAt) && item?.is_paid === 0
																	? "EXPIRED"
																	: item?.payment_status
																	? item?.payment_status
																	: "N/A"}
															</p>
														</td>
														<td>
															<p>{item?.p_token ?? "N/A"}</p>
														</td>
														<td>
															<p>{item?.p_txnld ?? "N/A"}</p>
														</td>
														<td>
															<p>{item?.payment_reference ?? "N/A"}</p>
														</td>
														<td>
															<p>{item?.payment_option ?? "N/A"}</p>
														</td>
														<td>
															<p className="text-muted">
																{item?.notify_date
																	? getDateFormatDisplay(item?.notify_date)
																	: "N/A"}
															</p>
														</td>
														<td>
															<p className="text-muted">
																{item?.createdAt
																	? getDateFormatDisplay(item?.createdAt)
																	: "N/A"}
															</p>
														</td>
													</tr>
												);
											})
										) : (
											<tr>
												<td colSpan={colSpan}>
													<p className="text-center">No Data</p>
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</TableContent>
						</Col>
					</Row>
				</Tab>
				<Tab
					eventKey={"form"}
					title={
						<div className="d-flex align-items-center justify-content-center">
							<Payment className="mr-1" />
							Form
						</div>
					}
					className="p-3"
				>
					<Row>
						<Col xs={12}>
							<Form as="form" onSubmit={handleSubmitForm}>
								<Form.Row>
									<Col xs={12} lg={6}>
										<Form.Group className="formGroup">
											<Form.Control
												id="orderId"
												as="input"
												placeholder="Enter Order ID"
												min={0}
												isValid={orderId && orderIdReg.test(orderId)}
												isInvalid={orderId && !orderIdReg.test(orderId)}
												value={orderId}
												onChange={(e) => handleChangeOrderId(e)}
											/>
											<Form.Control
												id="amount"
												as="input"
												placeholder="Enter Amount"
												min={0}
												isValid={amount && amountReg.test(amount)}
												isInvalid={amount && !amountReg.test(amount)}
												value={amount}
												onChange={(e) => handleChangeAmount(e)}
											/>

											<Button
												type="submit"
												variant="info"
												disabled={
													!(orderId && orderIdReg.test(orderId)) ||
													!(amount && amountReg.test(amount)) ||
													loading
												}
											>
												{loading ? <Spinner animation="border" size="sm" /> : "Generate"}
											</Button>
											{paymentLink && (
												<Button
													type="reset"
													variant="outline-danger"
													onClick={handleResetFormGenerate}
												>
													Clear
												</Button>
											)}
										</Form.Group>
									</Col>
								</Form.Row>
							</Form>
						</Col>
						<Col xs={12}>
							{loading ? (
								<div className="progress">
									<LinearProgress />
								</div>
							) : paymentLink ? (
								<PaymentLinkWrapper>
									<Link target="_blank" to={{ pathname: paymentLink }}>
										{paymentLink}
									</Link>
									<Tooltip title="Copy to clipboard" arrow>
										<Button
											variant="outline-info"
											className="copy-btn"
											onClick={() => handleCopyPaymentLink(paymentLink)}
										>
											<small className={`copy-feedback ${copied ? "active" : ""}`}>
												Copied
											</small>
											<AssignmentOutlined fontSize="small" />
										</Button>
									</Tooltip>
								</PaymentLinkWrapper>
							) : null}
						</Col>
					</Row>
				</Tab>
			</Tabs>

			{/* Toast */}
			{showToast && (
				<Toast
					ref={_toastRef}
					className={toastBgColor}
					onClose={() => setShowToast(false)}
					show={showToast}
					delay={6000}
					autohide
					style={{
						position: "fixed",
						top: 70,
						right: 35,
						zIndex: 1041,
					}}
				>
					<Toast.Header closeButton={false}>
						<p className="mr-auto p-2 text-dark">{toastMessage}</p>
					</Toast.Header>
				</Toast>
			)}
		</HelpPageWrapper>
	);
}

const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 30px 15px;
	min-height: 50vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	position: relative;

	@media (max-width: 989px) {
		padding-top: 70px;
	}
	& > div.row {
		background-color: #fff;
		padding: 30px 20px;
		border-radius: 10px;
		box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	}

	.nav-tabs {
		.nav-link {
			color: #dee2e6;
			transition: color 0.2s ease;
			border-top-left-radius: calc(0.3rem - 1px);
			border-top-right-radius: calc(0.3rem - 1px);
			border-color: #e9ecef #e9ecef #e9ecef;

			&.active {
				font-weight: 500;
				color: #007bff;
				border: 1px solid #dee2e6;
				border-bottom: 1px solid #fff;
				z-index: 3;
			}
		}
	}

	.tab-content {
		background: #fff;
		border: 1px solid #dee2e6;
		border-bottom-left-radius: calc(0.3rem - 1px);
		border-bottom-right-radius: calc(0.3rem - 1px);
		border-top-right-radius: calc(0.3rem - 1px);
	}

	.formGroup {
		display: flex;
		gap: 0.75rem;
	}

	.progress {
		display: block;
		padding: 1rem;
		border-radius: 0.5rem;
		background: #f6f6f6;
	}
`;

const PaymentLinkWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 1rem;
	border-radius: 0.5rem;
	background: #f6f6f6;

	a {
		word-break: break-all;
		font-size: 1.125rem;
	}

	.copy-btn {
		position: relative;

		.copy-feedback {
			position: absolute;
			top: -23px;
			left: 0;
			color: transparent;
			transform: translateY(30px) scale(0.25);
			transition: transform 0.3s linear, color 0.3s linear 0.05s;

			&.active {
				transform: translateY(0) scale(1);
				color: #6c757d;
			}
		}
	}
`;

const TableContent = styled.div`
	table {
		tr th {
			white-space: nowrap;
			width: initial;
			scrollbar-width: none;
		}

		thead tr th {
			white-space: nowrap;
			width: initial;
			vertical-align: middle;
		}

		tbody tr td {
			vertical-align: middle;

			p {
				white-space: nowrap;
			}
		}
	}

	padding-right: 6px;

	::-webkit-scrollbar {
		width: 9px;
		border-radius: 9px;
	}

	::-webkit-scrollbar-thumb {
		background: #dee2e6;
		border-radius: 9px;
	}

	.table-responsive {
		::-webkit-scrollbar {
			height: 9px;
			border-radius: 9px;
		}

		::-webkit-scrollbar-thumb {
			background: #dee2e6;
			border-radius: 9px;
		}
	}
`;

export default PaymentLink;
